import { cn } from '@zealot/ui/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import type * as React from 'react';

const containerVariants = cva('mx-auto w-full', {
  variants: {
    size: {
      sm: 'max-w-screen-sm',
      md: 'max-w-screen-md',
      lg: 'max-w-screen-lg',
      xl: 'max-w-screen-xl',
      '2xl': 'max-w-screen-2xl',
      full: 'max-w-full',
    },
    padding: {
      0: 'px-0',
      4: 'px-4',
      6: 'px-6',
      8: 'px-8',
    },
  },
  defaultVariants: {
    size: 'xl',
    padding: 4,
  },
});

function Container({
  className,
  size = 'xl',
  padding = 4,
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof containerVariants>) {
  return <div data-slot="container" className={cn(containerVariants({ size, padding, className }))} {...props} />;
}

export { Container, containerVariants };
